import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class RefundPolicyService {

  constructor(private http: HttpClient) { }

   getRefundPolicyHtml(horse_show_id: string, organizer_id: string) : Promise<string> {
    return new Promise((resolve, reject) => {
	    return this.http.get(AppSettings.API_ENDPOINT + 'refund_policies/horse_show_id/' + horse_show_id + '/organizer_id/' + organizer_id,
	    	this.DEFAULT_HTTP_HTML_OPTIONS).subscribe((response:any) => {

	        resolve(response);

	    },
	      error_response => {
	            if(error_response instanceof HttpErrorResponse){

					if(error_response.status == 404){
						resolve("Please check the event prize list for refund policy.");
					  } else {

	              reject(error_response.error);
					}
	            }
	            reject(error_response.data ? error_response.data : error_response);
	      });
	  });
  }


	DEFAULT_HTTP_HTML_OPTIONS = {
   	headers: new HttpHeaders({
        'Accept': 'text/html',
      	'Content-Type':  'text/html'})
   };

}
